/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ContractTypeV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Contract category for contracts
   */
  category: ContractTypeV1Dto.category;
  /**
   * The name of the contract-type.
   */
  name: string;
  /**
   * The order number of the contract-type.
   */
  order: number;
};
export namespace ContractTypeV1Dto {
  /**
   * Contract category for contracts
   */
  export enum category {
    SERVICE = 'Service',
  }
}
